import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { TABS } from '../constants/tabs';

export default function TabBar({ activeTab, setActiveTab }) {
  return (
    <div className="bg-[#1c1c1d] border-t border-[#2c2c2e] flex justify-around items-center py-2 pb-safe sticky bottom-0 z-10 box-border px-1">
      {TABS.map(tab => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`flex flex-col items-center justify-center p-2 flex-1 transition-colors ${
            activeTab === tab.id ? 'text-blue-500' : 'text-gray-500 hover:text-gray-400'
          }`}
        >
          <SafeIcon icon={tab.icon} className="text-[20px] mb-1" />
          <span className="text-[9px] font-medium tracking-tight truncate w-full text-center">{tab.label}</span>
        </button>
      ))}
    </div>
  );
}
